import React, { useEffect, useRef, useState } from "react"
import Esign from "../Esign"
import useToggle from "../../../../hooks/toggle";
import { selecteddocumentesign } from "../ReviewDocs";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { ALAPersonelprop, getexternaldocuments, getSavedOfferDetails } from "../../../../api/transaction";
import { useReactToPrint } from 'react-to-print';
import { CSpinner } from "@coreui/react";
const ALApersonelproperty= ()=>{
  const {id,user} : any = useParams()
  const componentRef = useRef();
  const [loader,setloading] = useState(false)
const [personelprop,setPersonelprop] = useState({
  
    offer_id: Number(id),
    purchase_aggrement_date: null,
    address: "",
    city: "",
    state: "",
    zipcode: "",
    sumof: "",
    comments: "",
    buyer1: "",
    buyer1_date: null,
    buyer2: "",
    buyer2_date: null,
    seller1: "",
    seller1_date: null,
    seller2: "",
    seller2_date: null,
  
})

 // @ts-ignore
 const val = useSelector((state)=>state?.new?.signset)
const [canvasmodal, setCanvasModal] = useToggle(false);
const [offerdetails, setOfferDetails] = useState({});
const [htmlContent, setHtmlContent] = useState("");
const [selecteddocumentesign, setselectedDocumentEsign] = useState<selecteddocumentesign>({
    offerid : "",
  document_name: "",
  image_base64: "",
  sign_role: 1
  })

  const printf = () => {
    // window.print()
    handlePrint()
};

useEffect(()=>{
  if(val){
    if(user == "seller"){
      setPersonelprop({ ...personelprop, seller1: val }) 
    }
    if(user == "client"){
      setPersonelprop({ ...personelprop, buyer1: val }) 
    }
  }
  },[val])

  const send = async() => {
    setloading(true)
    if(user === "seller"){

      if(personelprop?.seller1){
        let res = await ALAPersonelprop(personelprop)
        if(res?.status == "success"){
          alert("Submitted Successfully")
      }
      else{
          alert("Something went wrong")
      }
      }
    }
    else if(user === "client"){
 
      if(personelprop?.buyer1){
        let res = await ALAPersonelprop(personelprop)
        if(res?.status == "success"){
          alert("Submitted Successfully")
      }
      else{
          alert("Something went wrong")
      }
     
      }
    }
    setloading(false)
};
useEffect(()=>{
  (async function(){
    let offerdetails = await getSavedOfferDetails(id)
        setOfferDetails(offerdetails[0])
    const res =await getexternaldocuments(id,"personalproperty") 
    setPersonelprop({...personelprop,
      purchase_aggrement_date:res?.data?.purchase_aggrement_date,
      address: res?.data?.address,
      city: res?.data?.city,
      state: res?.data?.state,
      zipcode: res?.data?.zipcode,
      sumof: res?.data?.sumof,
      comments: res?.data?.comments,
      buyer1: res?.data?.buyer1,
      buyer1_date: res?.data?.buyer1_date,
      buyer2: res?.data?.buyer2,
      buyer2_date: res?.data?.buyer2_date,
      seller1: res?.data?.seller1,
      seller1_date: res?.data?.seller1_date,
      seller2: res?.data?.seller2,
      seller2_date: res?.data?.seller2_date,
      
    })
  })()
},[])

const handlePrint = useReactToPrint({
  content: () => componentRef.current,
});

    return(
        <>
        <table
  style={{ width: 1100, margin: "0 auto", background: "#fff", padding: 15 }} ref={componentRef}
>
  <tbody>
    <tr>
      <td>
        <table style={{ width: "100%" }}>
          <tbody>
            <tr>
              <td style={{ width: "90%" }}>
                <img
                  style={{ width: 250 }}
                  src="https://storagemilforddev.blob.core.windows.net/images/logo.svg"
                />
              </td>
              <td>
                <img
                  style={{ width: 30 }}
                  src="https://storagemilforddev.blob.core.windows.net/images/realtor.svg"
                  alt=""
                />
                <img
                  style={{ width: 50 }}
                  src="https://storagemilforddev.blob.core.windows.net/images/eh.svg"
                  alt=""
                />
              </td>
            </tr>
          </tbody>
        </table>
      </td>
    </tr>
    <tr>
      <td style={{ padding: "15px 0px" }}>
        <span style={{ fontSize: 20, fontWeight: 700 }}>
          Personal Property Bill of Sale
        </span>
      </td>
    </tr>
    <tr>
      <td style={{ padding: "15px 0px" }}>
        <span>
          This agreement is for the sale of personal property in connection with
          the Purchase Agreement dated:
          <input
            type="date"
            value={personelprop?.purchase_aggrement_date}
            onChange={(e)=>setPersonelprop({...personelprop,purchase_aggrement_date:e.target.value})}
            style={{
              outline: "none",
              border: "none",
              borderBottom: "1px solid black",
              width: 100
            }}
          />{" "}
          for the real property commonly known as:
        </span>
      </td>
    </tr>
    <tr>
      <td style={{ padding: "15px 0px" }}>
        <span>
          Address:
          <input
            type="text"//@ts-ignore
            value={offerdetails?.propertyAddress}
            // onChange={(e)=>setPersonelprop({...personelprop,address:e.target.value})}
            style={{
              outline: "none",
              border: "none",
              borderBottom: "1px solid black",
              width: "90%"
            }}
          />{" "}
          city:
          <input
            type="text"
            value={personelprop?.city}
            onChange={(e)=>setPersonelprop({...personelprop,city:e.target.value})}
            style={{
              outline: "none",
              border: "none",
              borderBottom: "1px solid black",
              width: "40%"
            }}
          />
          state:
          <input
            type="text"
            value={personelprop?.state}
            onChange={(e)=>setPersonelprop({...personelprop,state:e.target.value})}
            style={{
              outline: "none",
              border: "none",
              borderBottom: "1px solid black",
              width: "30%"
            }}
          />
          Zip:{" "}
          <input
            type="text"
            value={personelprop?.zipcode}
            onChange={(e)=>setPersonelprop({...personelprop,zipcode:e.target.value})}
            style={{
              outline: "none",
              border: "none",
              borderBottom: "1px solid black",
              width: "10%"
            }}
          />
        </span>
      </td>
    </tr>
    <tr>
      <td>
        <span>
          The Seller(s) of the above-referenced property will sell the following
          items of personal property, which will remain with the real property.
          The Seller(s) hereby grants transfer or sale of the following goods
          for the sum of $
          <input
            type="text"
            value={personelprop?.sumof}
            onChange={(e)=>setPersonelprop({...personelprop,sumof:e.target.value})}
            style={{
              outline: "none",
              border: "none",
              borderBottom: "1px solid black",
              width: "15%"
            }}
          />
        </span>
      </td>
    </tr>
    <tr>
      <td style={{ padding: "15px 0px" }}>
        <span>
          <textarea
           value={personelprop?.comments}
           onChange={(e)=>setPersonelprop({...personelprop,comments:e.target.value})}
            style={{
              width: "100%",
              height: 300,
              outline: "none",
              resize: "none",
              backgroundColor: "#e2e0f9"
            }}
            defaultValue={""}
          />
        </span>
      </td>
    </tr>
    <tr>
      <td>
        <span style={{ fontWeight: 700, color: "#3b0083" }}>
          The Seller(s) warrants that the personal property listed above is free
          and clear of any and all liens, encumbrances and debt and that they
          are the lawful owner of the goods listed above. The Seller(s) renders
          full rights and ownership of the goods listed above to the Buyer(s) at
          the closing of the real property as specified above. If the sale of
          the real property is not executed, this agreement will become null and
          void
        </span>
      </td>
    </tr>
    <tr>
      <td style={{ padding: "50px 0px" }}>
        <table style={{ width: "100%" }}>
          <tbody>
            <tr>
              <td>
                <span>
                  <img

                    src={user === "client" ? (val || personelprop?.buyer1) : personelprop?.buyer1}
                   
                    style={{
                      outline: "none",
                      border: "none",
                      borderBottom: "1px solid #3b0083",
                      width: "100px"
                    }}
                  />
                </span>
                <table style={{ width: "100%" }}>
                  <tbody>
                    <tr>
                      <td style={{ width: "100%" }}>
                        <span>Buyer </span>
                      </td>
                      <td>
                      <input type="date" 
                           value={personelprop?.buyer1_date ? personelprop?.buyer1_date : (user === "client" && val || personelprop?.buyer1) ? new Date().toISOString().split('T')[0] : ""}
                           onChange={(e)=>setPersonelprop({...personelprop,buyer1_date:e.target.value})}
                        />
                        date</td>
                    </tr>
                  </tbody>
                </table>
              </td>
              <td>
                <span>
                  <img
                   src={user === "seller" ?  (val || personelprop?.seller1) : personelprop?.seller1 }
                    style={{
                      outline: "none",
                      border: "none",
                      borderBottom: "1px solid #3b0083",
                      width: "100px"
                    }}
                  />
                </span>
                <table style={{ width: "100%" }}>
                  <tbody>
                    <tr>
                      <td style={{ width: "100%" }}>
                        <span>sellar </span>
                      </td>
                      <td>
                        <input type="date" 
                           value={personelprop?.seller1_date  ? personelprop?.seller1_date :  (user === "seller" && val || personelprop?.buyer1) ? new Date().toISOString().split('T')[0] : ""}
                           onChange={(e)=>setPersonelprop({...personelprop,seller1_date:e.target.value})}
                        />
                        date</td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </td>
    </tr>
    <tr>
      <td>
        <table style={{ width: "100%" }}>
          <tbody>
            <tr>
              <td>
                <span>
                  <input
                    type="text"
                    style={{
                      outline: "none",
                      border: "none",
                      borderBottom: "1px solid #3b0083",
                      width: "100%"
                    }}
                  />
                </span>
                <table style={{ width: "100%" }}>
                  <tbody>
                    <tr>
                      <td style={{ width: "100%" }}>
                        <span>Buyer </span>
                      </td>
                      <td>
                     
                        date</td>
                    </tr>
                  </tbody>
                </table>
              </td>
              <td>
                <span>
                  <input
                    type="text"
                    style={{
                      outline: "none",
                      border: "none",
                      borderBottom: "1px solid #3b0083",
                      width: "100%"
                    }}
                  />
                </span>
                <table style={{ width: "100%" }}>
                  <tbody>
                    <tr>
                      <td style={{ width: "100%" }}>
                        <span>sellar </span>
                      </td>
                      <td>date</td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </td>
    </tr>
    <tr>
      <td style={{ paddingTop: 300 }}>
        <span>
          ther provisions: Earnest deposit to be delivered within (5) business
          days.
        </span>
      </td>
    </tr>
  </tbody>
</table>
<React.Fragment>
<div className="d-flex align-items-center justify-content-end mb-2 mr-2">
    <button onClick={send} className="btn primaryColorBtn">Submit
    {loader && <CSpinner color="dark" size="sm" className={'ml-1'} />}
    </button>
    <button onClick={printf} className="btn print-doc-btn mx-2">Print</button>
    <button className="signaturebtn btn mb-0" onClick={() => setCanvasModal()}>Signature</button> 
</div>
          </React.Fragment>
<Esign
        canvasmodal={canvasmodal}
        setCanvasModal={setCanvasModal}
        htmlContent={htmlContent}
        setHtmlContent={setHtmlContent}
        selecteddocumentesign={selecteddocumentesign}
        setselectedDocumentEsign={setselectedDocumentEsign}
        type={"seller"}
      ></Esign>
        </>
    )
}
export default ALApersonelproperty